import { roomId, userId, userRole } from "./getWebserver"
import { AGORA_VENDOR, MBS_VENDOR } from "@/constants"
let strategy = {
  [AGORA_VENDOR]: () => {
    return {
      vendor: AGORA_VENDOR,
      userId,
      roomId,
      userRole
    }
  },
  [MBS_VENDOR]: () => {
    return {
      vendor: MBS_VENDOR,
      userId,
      roomId,
      userRole
    }
  },
  vk: () => {
    return {
      vendor: "vk",
      userId,
      roomId,
      userRole
    }
  }
}
let getMediaEnterParams = (leval, params) => {
  return strategy[leval](params)
}

export default getMediaEnterParams
